import { config } from '@iheartjane/config';
import { initializeApi } from '@iheartjane/data-access';
import { useRuntimeConfig } from '@iheartjane/runtime-config';
import {
  initMoengage,
  initTrackJS,
  registerErrorMetadata,
} from '@iheartjane/tracking';
import { useRoutes } from 'react-router';

import { Modals } from '@jane/monolith/components/modals';
import { SkipLinks } from '@jane/monolith/components/skipLinks';
import { CustomerGlobal } from '@jane/monolith/style/customerGlobal';
import { initAlgoliaInsights } from '@jane/shared-ecomm/tracking';
import { useEcommApp } from '@jane/shared/providers';
import {
  initCrmMixpanel,
  initMixpanel,
  setPartnerHostedConfig,
} from '@jane/shared/util';

import { buildBoostForAllRoutes } from './app/boost-for-all-routes';
import { useScrollToApp } from './app/hooks/useScrollToApp';
import { buildRoutes } from './app/routes';
import ShadowRoot from './shadow-root';

initMoengage({
  debug: config.moengageDebug,
  env: config.moengageEnv,
  workspaceId: config.moengageWorkspaceId,
});
initMixpanel(config.mixpanelCustomerToken, {
  useLocalStorage: true,
});
initCrmMixpanel(config.mixpanelCrmToken);
initTrackJS({
  application: config.trackJsApplication,
  forwardingDomain: config.trackJsDomain,
  token: config.trackJsToken,
  version: config.appVersion,
});
initAlgoliaInsights();
initializeApi({ baseUrl: config.apiPathBase });

const App = () => {
  const { appMode } = useEcommApp();
  registerErrorMetadata('appMode', appMode);
  useScrollToApp('shadow-host');

  const { isPartnerHosted, partnerHostedPath, isBoostForAll } =
    useRuntimeConfig();

  const routes = isBoostForAll
    ? buildBoostForAllRoutes()
    : buildRoutes(isPartnerHosted, partnerHostedPath);

  const routing = useRoutes(routes);
  setPartnerHostedConfig({ isBoostForAll, isPartnerHosted, partnerHostedPath });

  if (!isPartnerHosted) return <div>Partner Config Not Found!</div>;

  return (
    <ShadowRoot>
      <CustomerGlobal />
      <SkipLinks />
      <Modals />
      <div style={{ minHeight: '100vh' }}>{routing}</div>
    </ShadowRoot>
  );
};

export default App;
